import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuTrigger,
} from "@/components/ui/context-menu"
import { ReactNode } from "react"

function ContextContainer({trigger, children}: {trigger: ReactNode, children: ReactNode}) {
  return (
    <ContextMenu>
      <ContextMenuTrigger onContextMenu={e => e.stopPropagation()} >{trigger}</ContextMenuTrigger>
      <ContextMenuContent>
        {children}
      </ContextMenuContent>
    </ContextMenu>
  )
}

export default ContextContainer